module.exports = __webpack_public_path__ + "static/media/asl.17fa69aa.jpeg";